import { Button } from '@mantine/core';
import { ButtonProps } from '@mantine/core';

interface CreateSubscriptionButtonProps extends ButtonProps {
    onClick: () => void;
    loading?: boolean;
}

export const CreateSubscriptionButton = ({ onClick, loading, ...props }: CreateSubscriptionButtonProps) => (
    <Button
        size="lg"
        loading={loading}
        onClick={onClick}
        {...props}
    >
        Create Subscription
    </Button>
);